var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process"},[_c('button',{class:{
      'swal2-confirm': _vm.canProcessData,
      'swal2-cancel': !_vm.canProcessData,
      'swal2-styled': true,
    },attrs:{"disabled":!_vm.canProcessData},on:{"click":_vm.onProcess}},[_vm._v(" Process ")])])}
var staticRenderFns = []

export { render, staticRenderFns }